import Alert from '../../../../Modals/Alert';
import Button from '../../../../Button';
import AlertCircle from '../../../../../assets/svg/Feather/AlertCircle';
import Check from '../../../../../assets/svg/Feather/Check';
import ghAnalytics from '../../../../../lib/analytics';


export default (dispatch) => {
  return {
    removeFromCollection: (feature, collection) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            title: `Are you sure you want to remove this feature from "${collection.title}" hunt?`,
            subtitle: '',
            actionItems: [{
              title: 'Remove',
              onClick: () => {
                dispatch({
                  type: 'toast/show',
                  payload: {
                    text: 'Removing feature from hunt...',
                    loader: true,
                  }
                });
  
                dispatch({
                  type: 'modals/close'
                });
  
                dispatch({
                  type: 'collections/removeFeaturesFromCollectionEffect',
                  payload: {
                    featureIds: [feature.uuid],
                    collectionId: collection.uuid
                  },
                  callback: (result) => {
                    if (!result) {
                      dispatch({
                        type: 'toast/show',
                        payload: {
                          text:
                            'There was an issue in removing you feature.',
                          icon: AlertCircle,
                          iconColor: '#ff3b30',
                          dismissable: true,
                        },
                      });
                    } else {
                      ghAnalytics.logCollectionItemDeleted(collection, feature);
  
                      dispatch({
                        type: 'features/updateSelectedFeature',
                        payload: {
                          ...feature,
                          collectionIds: feature.collectionIds.filter(
                            (colId) => colId != collection.uuid
                          )
                        }
                      });
  
                      dispatch({
                        type: 'features/removeCollectionFromFeaturesList',
                        payload: {
                          featureId: feature.uuid,
                          collectionId: collection.uuid
                        }
                      });
  
                      dispatch({
                        type: 'collections/removeFeatureFromCollectionsList',
                        payload: {
                          featureId: feature.uuid,
                          collectionId: collection.uuid
                        }
                      });
  
                      dispatch({
                        type: 'toast/show',
                        payload: {
                          text: 'Feature removed from hunt',
                          icon: Check,
                          iconColor: '#f37735'
                        }
                      });
  
                      setTimeout(() => {
                        dispatch({
                          type: 'toast/dismiss'
                        });
                      }, 3500);
                    }
                  }
                });
              }
            }, {
              title: 'Cancel',
              theme: Button.THEME.outlinePrimary,
              onClick: () => {
                dispatch({
                  type: 'modals/close'
                });
              },
            }]
          }
        }
      });
    }
  };
};